document.querySelectorAll('.show_password, .hide_password').forEach(function(element) {
  element.addEventListener('click', function() {
    var passwordId = this.closest('.customer-login-form-wrapper .field').querySelector('input').id;
    var passwordInput = document.getElementById(passwordId);
    if (this.classList.contains('show_password')) {
      passwordInput.type = 'text';
      this.parentNode.querySelector('.show_password').style.display = 'none';
      this.parentNode.querySelector('.hide_password').style.display = 'inline';
    } else {
      passwordInput.type = 'password';
      this.parentNode.querySelector('.hide_password').style.display = 'none';
      this.parentNode.querySelector('.show_password').style.display = 'inline';
    }
  });
});
